export const BrandMark = ({ className = "w-7 h-7 text-gold" }) => (
  <svg
    className={className}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    aria-hidden="true"
  >
    <circle cx="12" cy="12" r="9"></circle>
    <path d="M7 12h10M12 7l5 5-5 5"></path>
  </svg>
);

export default function Nav() {
  return (
    <header className="border-b border-line sticky top-0 bg-ground/90 backdrop-blur z-50">
      <div className="max-w-6xl mx-auto px-6 h-20 flex items-center justify-between">
        <a href="#top" className="flex items-center gap-3" data-testid="nav-brand">
          <BrandMark />
          <span className="text-xl font-bold tracking-tight text-white uppercase">
            THE ABSTRACTS
          </span>
        </a>
        <nav className="hidden md:flex items-center gap-8 text-xs mono-tag tracking-widest uppercase text-slate-400">
          <a href="#gallery" className="hover:text-white transition-colors" data-testid="nav-catalog-link">
            Catalog
          </a>
          <a
            href="#add-piece"
            className="text-gold hover:underline flex items-center gap-1.5 font-bold"
            data-testid="nav-add-piece-link"
          >
            <span>+</span> Add Your Pieces
          </a>
          <a href="#commissions" className="hover:text-white transition-colors" data-testid="nav-commissions-link">
            Commissions
          </a>
        </nav>
        <div className="flex items-center gap-3">
          <a
            href="#add-piece"
            className="px-3.5 py-2 border border-gold text-gold text-xs font-bold uppercase tracking-wider hover:bg-gold hover:text-black transition-colors"
            data-testid="nav-add-piece-btn"
          >
            + Add Piece
          </a>
          <a
            href="#commissions"
            className="px-4 py-2 bg-gold text-black text-xs font-bold uppercase tracking-wider hover:bg-gold-hover transition-colors"
            data-testid="nav-commission-btn"
          >
            Commission
          </a>
        </div>
      </div>
    </header>
  );
}
